export default __webpack_public_path__ + "static/media/FX.4edbc3f9.webm";